import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Flex } from 'antd';
import { isCaptain } from '@/shared/utils/users';
import { handleInvite } from '@/shared/utils/referralLink';
import { ITeam } from '../types';
import { IUser } from '@/entities/user/types';
import { TeamLeaderOptions } from './TeamLeaderOptions';
import { TeamMemberOptions } from './TeamMemberOptions';

import ImgTeamBorder from '@/shared/pictures/team_border.png';


interface TeamItemProps {
  user:IUser
  team:ITeam
  link:string
}


export const TeamInfo:FC<TeamItemProps> = observer(({user,team,link}) => {
  const isCaptainRes = isCaptain(user.id, team.members);
  return (
    <div className='team_info'>
      <div className='team_img-block'>
        <img className='team_img' src={team.imageUrl} alt="team-img"/>
        <img className='team_border' src={ImgTeamBorder} alt="team-img"/>
      </div>
      <Flex vertical gap={12}>
        <p className='team_name'>{team.name}</p>
        <p className='team_text'>Участников: <span>{team.membersCount}</span></p>
        <p className='team_text'>Шайб забито: <span>{team.totalScore}</span></p>
        <p className='team_text'>Место в рейтинге: <span>{team.rating}</span></p>

        {isCaptain(user.id, team.members)&&
            <div className='team_button' onClick={()=>handleInvite(link, 'Создал команду в приложении Александра Овечкина в Telegram. Присоединяйся, будем участвовать в турнирах. Погнали?')}>Пригласить участников</div>
        }
      </Flex>
      
      { isCaptainRes != null?
          isCaptainRes
            ?<TeamLeaderOptions/>
            :<TeamMemberOptions/> 
        :null
      }
  </div>

);
});